<template>
  <section id="dashboard-analytics">
    <campaign-header
      ref="campaignHeader"
      :is-free="is_free"
      :group-rol="groupRol"
      :campaign-avaible="campaign_avaible"
      @open-modal-create="openModalCreate"
    />
    <hr class="mb-3">

    <b-modal
      :key="change"
      v-model="sidebar_right"
      size="lg"
      hide-footer
      hide-header
      centered
      body-class="p-0 campaign-create-modal-body"
      modal-class="campaign-create-modal"
    >
      <sidebar-content
        :key="change"
        @campaignCreated="appendCampaign"
        @update_campaigns_avaible="campaign_avaible -= 1; sidebar_right = false"
      />
    </b-modal>

    <campaign-tabs
      :active-campaigns="active_campaigns"
      :archived-campaigns="archive_campaigns"
      :loading="loading"
      :change-key="change_campaigns"
      @archived="onArchived"
      @desarchived="onDesarchived"
      @deleted="deletedCampaign"
    />

    <modal-membership-section
      :text_selected_dad="text_selected" 
      :open_modal="modal_membership"
      @close_modal="modal_membership = false"
      :key="update_modal"
    />
  </section>
</template>
<script>
import { BModal, VBToggle } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import service from '@/services/dashboard'
import service_profile from '@/services/others'
import { getUserData } from '@/libs/utils/user'
import { getMotivationalPhrase } from '@/libs/utils/others'

export default {
  name: 'CampaignV2',
  components: {
    BModal,
    SidebarContent: () => import('@/views/dashboard/newCampaign.vue'),
    CampaignHeader: () => import('@/views/campaings/campaigns/CampaignHeader.vue'),
    CampaignTabs: () => import('@/views/campaings/campaigns/CampaignTabs.vue'),
    ModalMembershipSection: () => import('@/views/components/modal/ModalMembershipSection.vue')
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  data () {
    return {
      getMotivationalPhrase,
      campaigns: [],
      change: false,
      groupRol: 'brand',
      active_campaigns: [],
      archive_campaigns: [],
      change_campaigns: false,
      loading: false,
      interval_loading: null,
      campaign_avaible: 0,
      text_selected: 'campaigns',
      modal_membership: false,
      update_modal: 1,
      sidebar_right: false,
    }
  },
  computed: {
    is_free() {
      return getUserData().current_plan.name === 'Free'
    },
    limit_internal_campaigns() {
      return getUserData().current_plan.limit_internal_campaigns;
    }
  },
  mounted () {
    this.getCampaigns()
    const data_user = JSON.parse(localStorage.getItem('userData'));
    this.groupRol = data_user.main_group.name;

    service_profile.getMaxViews()
      .then(response => {
        this.$root.$emit('change_max_views', response.max_views)
      })

    if (this.is_free) this.getTotalCampaigns();
  },
  methods: {
    openModalCreate() {
      if (this.limit_internal_campaigns !== -1 && this.campaign_avaible <= 0) {
        this.modal_membership = true;
        this.update_modal += 1;
      } else {
        this.sidebar_right = true;
      }
    },
    getTotalCampaigns() {
      service.getTotalCampaigns().then((response) => {
        this.campaign_avaible = this.limit_internal_campaigns - response.total_campaigns;
      })
    },
    updateCampaignCounts() {
      this.change_campaigns = !this.change_campaigns;
    },
    onArchived(data) {
      const index = this.active_campaigns.findIndex(c => c.uuid === data.uuid);
      if (index !== -1) {
        this.active_campaigns.splice(index, 1);
        data.is_archived = true;
        this.archive_campaigns.push(data);
      }
      this.updateCampaignCounts();
    },
    onDesarchived(data) {
      const index = this.archive_campaigns.findIndex(c => c.uuid === data.uuid);
      if (index !== -1) {
        this.archive_campaigns.splice(index, 1);
        data.is_archived = false;
        this.active_campaigns.push(data);
      }
      this.updateCampaignCounts();
    },
    deletedCampaign(is_archived, uuid) {
      const targetArray = is_archived ? this.archive_campaigns : this.active_campaigns;
      const index = targetArray.findIndex(c => c.uuid === uuid);
      if (index !== -1) {
        targetArray.splice(index, 1);
      }
      if (this.is_free) this.campaign_avaible += 1;
      this.updateCampaignCounts();
    },
    filterActiveCampaigns() {
      return this.campaigns.filter(campaign => campaign.active && !campaign.is_archived);
    },
    filterArchivedCampaigns() {
      return this.campaigns.filter(campaign => campaign.active && campaign.is_archived);
    },
    getCampaigns() {
      this.loading = true;
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]
        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(() => prev_loading.remove(), 500);
          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);

      service.getCampaign()
        .then(response => {
          this.campaigns = response.response.results;
          this.active_campaigns = this.filterActiveCampaigns();
          this.archive_campaigns = this.filterArchivedCampaigns();
          this.updateCampaignCounts();
          this.loading = false;
          clearInterval(this.interval_loading);
          this.$vs.loading.close();
        })
    },
    appendCampaign(campaign) {
      this.sidebar_right = false;
      this.campaigns.unshift(campaign);
      this.active_campaigns.unshift(campaign);
      this.updateCampaignCounts();
      this.change = !this.change;
    }
  },
  watch: {
    '$i18n.locale'() {
      this.change = !this.change;
    }
  }
}
</script>

<style lang="scss">
.campaign-create-modal .modal-dialog {
  max-width: 640px;
}
.campaign-create-modal-body {
  border-radius: 8px;
  overflow: hidden;
}
</style>
